
import React from 'react';
import './TermsOfUse.scss';
// Importez votre composant ConditionsLink si vous l'avez implémenté en React
// import ConditionsLink from '../ConditionsLink/ConditionsLink';

const TermsOfUse = ({ useConditionsLink = true }) => {
    // Fonction pour générer une section sous forme de "card"
    const buildSection = (title, content) => (
        <div className="policy-card">
            <h3>{title}</h3>
            <p>{content}</p>
        </div>
    );

    // Contenu principal (équivalent au SingleChildScrollView)
    const content = (
        <div className="terms-of-use-content">
            <h2 className="policy-title">Conditions d'utilisation</h2>

            {buildSection(
                'Introduction',
                "En utilisant Thespot, vous acceptez les termes et conditions suivants. Ces conditions régissent votre utilisation de l'application et de ses services. ABI'S COMPANY détient les droits exclusifs sur l'application."
            )}

            {buildSection(
                "1. Objet de l'application",
                "L'application Thespot vous permet de rechercher des restaurants, de laisser des avis, et de partager des photos. Elle est uniquement disponible en France."
            )}

            {buildSection(
                '2. Inscription et gestion du compte',
                `- L'inscription se fait via votre identifiant Apple, sans gestion de mot de passe.
- L'utilisation de l'application est limitée à la France et sans restriction d'âge.
- Vous êtes responsable de la gestion de votre compte et de vos informations personnelles. Vous devez maintenir la confidentialité de votre identifiant Apple et de votre appareil.`
            )}

            {buildSection(
                '3. Droits et obligations des utilisateurs',
                `- Vous avez le droit de publier des photos et des avis, à condition que vous respectiez les lois et la décence.
- Il est interdit de publier des contenus diffamatoires, offensants, ou en violation des lois locales.
- L'utilisateur s'engage à ne pas publier de spam, de faux avis ou de contenus nuisibles.`
            )}

            {buildSection(
                '4. Propriété intellectuelle',
                `- Les utilisateurs conservent la propriété de leurs contenus, mais ils accordent à Thespot une licence pour utiliser, afficher et distribuer leurs photos et avis dans le cadre de l'application.
- Thespot possède tous les droits de propriété intellectuelle relatifs à l'application et à son contenu.`
            )}

            {buildSection(
                '5. Utilisation des données personnelles',
                `- Nous collectons des données personnelles, telles que l'email et l'historique de recherche, pour personnaliser l'expérience de l'utilisateur.
- Vos données seront conservées pendant 1 an, après quoi elles seront supprimées.`
            )}

            {buildSection(
                '6. Partage des données',
                "Aucune donnée personnelle n'est partagée avec des tiers sans votre consentement."
            )}

            {buildSection(
                "7. Modifications des conditions d'utilisation",
                "Nous nous réservons le droit de modifier ces conditions d'utilisation à tout moment. Les utilisateurs seront informés des modifications via une notification dans l'application et devront accepter les nouvelles conditions pour continuer à utiliser les services."
            )}

            {buildSection(
                '8. Résiliation du compte',
                "Nous pouvons suspendre ou résilier votre compte si vous violez ces conditions ou si des activités frauduleuses sont détectées."
            )}

            {buildSection(
                '9. Limitation de responsabilité',
                `- Thespot n'est pas responsable des dommages directs ou indirects causés par l'utilisation de l'application, y compris, mais sans s'y limiter, la perte de données, l'indisponibilité des services, ou les actions illégales d'utilisateurs.
- Vous êtes responsable de l'utilisation de l'application et de la gestion de vos informations personnelles.`
            )}

            {buildSection(
                "10. Loi applicable et résolution des conflits",
                "Ces conditions sont régies par la loi française. En cas de litige, les parties tenteront de résoudre le conflit de manière amiable. Si cela échoue, le tribunal compétent sera celui de votre lieu de résidence en France."
            )}

            <div className="policy-card">
                <p className="contact-text">
                    Pour toute question ou préoccupation, contactez-nous à :
                </p>
                <a href="mailto:contact.thespot.mail@gmail.com" className="email-link">
                    contact.thespot.mail@gmail.com
                </a>
            </div>
        </div>
    );

    // Si useConditionsLink est true, on enveloppe le contenu dans ConditionsLink
    if (useConditionsLink) {
        return (
            // Remplacez ce placeholder par votre composant ConditionsLink si disponible
            <div className="placeholder-conditions-link">
                <p>
                    Cliquez ici pour afficher les conditions d'utilisation (ex. modal/bottom sheet).
                </p>
            </div>
        );
    }

    return content;
};

export default TermsOfUse;
